import {IconButton, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {Description, FileDownload, Summarize} from "@mui/icons-material";
import React from "react";
import { selectModeData } from "../../../redux/selectors/editor";
import { IScriptData, UpdateModeData, updateModeData } from "../../../redux/slices/editor";
import { connect } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    toggleGroup: {
        marginRight: theme.spacing(1)
    },
    toggleButton: {
        color: theme.palette.common.white,
        "&.Mui-selected": {
            color: theme.palette.common.white
        }
    }
}));

export interface Props
{
    scriptData: IScriptData
    updateModeData: UpdateModeData
}
function ScriptTools({ scriptData, updateModeData }: Props)
{
    const classes = useStyles();

    return (
        <>
            {scriptData.scriptMode === "paged" &&
                <IconButton color="inherit" disabled={scriptData.exportDocX} onClick={() =>
                    updateModeData({exportDocX: true})} title="Export script in docx format">
                    <FileDownload/>
                </IconButton>
            }
            <ToggleButtonGroup value={scriptData.scriptMode} exclusive className={classes.toggleGroup}
                               onChange={(event, value) => {
                                   updateModeData({ scriptMode: value })
                               }} size="small">
                <ToggleButton className={classes.toggleButton} value={"paged"} title="Paged">
                    <Description color="inherit" />
                </ToggleButton>
                <ToggleButton className={classes.toggleButton} value={"interactive"} title="Interactive">
                    <Summarize color="inherit" />
                </ToggleButton>
            </ToggleButtonGroup>
        </>
    );
}

const mapStateToProps = (store: never) => ({
    scriptData: selectModeData(store) as IScriptData
});
export default connect(mapStateToProps, {
    updateModeData
})(ScriptTools);
